import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UnidadeService } from 'src/app/services/http/unidade.service';
import { LoginService } from 'src/app/services/login.service';
import { first } from 'rxjs/operators';
import { Usuario } from 'src/app/models/usuario-login';

@Component({
  selector: 'app-list-tipo-unidade',
  templateUrl: './list-tipo-unidade.component.html',
  styleUrls: ['./list-tipo-unidade.component.scss']
})
export class ListTipoUnidadeComponent implements OnInit {

  usuario: Usuario;
  listaTipoUnidade = [];
  cliente:boolean = false;
  
  first: number = 0;
  unidade: any = {};
  dynamicdownloadName: string = "Tipos de Unidades"

  cols: any = [
    { field: 'nome', header: 'Tipo de Unidade' },
    { field: 'nivel', header: 'Nível' },
    { field: 'descricao', header: 'Descrição' }
  ];

  constructor(private loginService: LoginService, private activatedRoute: ActivatedRoute, private router: Router, private unidadeService: UnidadeService) {
    this.loginService.getLogIn().pipe(first()).subscribe(u => this.usuario = u);
    this.cliente = this.activatedRoute.snapshot.data.cliente || false;
    this.unidadeService.getListaTipoUnidade().then(r => this.listaTipoUnidade = r);
  }

  ngOnInit() {
  }

  editar(id) {
    this.router.navigate(['unidade','tipo','editar', id]);
  }

  cadastrar() {
    this.router.navigate(['unidade','tipo','adicionar']);
  }

}
